
import { Component, Prop, Vue } from 'vue-property-decorator';
import Question from '@/components/Question.vue';
import store from '@/store';
import { default as StepEntity } from '@/lib/Step.ts';
import ArraySection from '@/components/ArraySection.vue';
import Preloader from '@/components/Preloader.vue';
import { IconRegistry } from '@/lib/IconRegistry';
import Section from '@/lib/Section';
import { ResponseGroup } from '../lib/ResponseGroup';

@Component(
    {
        components: {
            ArraySection,
            Preloader,
            Question,
        },
    },
)
export default class Step extends Vue {
    @Prop() public step: StepEntity;
    public stepIsFirst = true;
    public stepIsLast = false;
    public mainProgressHidden = false;
    public currentQuestion = this.$store.state.currentBranch.currentQuestion;
    public nextDisabled = true;
    // public nextDisabled = (this.$store.state.currentBranch.currentQuestion.required && this.$store.state.currentBranch.currentQuestion.currentResponseIsEmpty()) || !this.$store.state.currentBranch.currentQuestion.good;

    public previousQuestion() {
        this.$store.state.currentBranch.previous();
        this.currentQuestion = this.$store.state.currentBranch.currentQuestion;
        this.disable();
    }
    public getLastStepButtonText() {
        const responseGroup = this.$store.state.currentResponseGroup as ResponseGroup;
        if (!responseGroup.branch.activateComparison) {
            return 'Demander une quotation';
        }
        if (responseGroup.contractGroup) {
            return 'Enregistrer';
        }
        return 'Comparer';
    }


    public next() {
        this.$store.state.currentBranch.next();
        this.currentQuestion = this.$store.state.currentBranch.currentQuestion;
        this.disable();
    }

    public disable() {

        this.nextDisabled = (this.currentQuestion.required && this.currentQuestion.currentResponseIsEmpty()) || !this.currentQuestion.good;
    }

    public disableNextStep() {
        return !this.$store.state.currentStep.isBlank && (!this.$store.state.currentStep.isValid || this.$store.state.answerSavingNumber > 0);
    }

    public displayHome() {
        this.$router.replace('/');
    }

    public previousStep() {
        this.$store.state.currentResponseGroup.previousStep();
        this.checkStep();
        this.fixIllustration();
        window.scrollTo(0, 0);
        this.$store.state.currentStep.validate();
    }

    public nextStep() {
        this.$store.state.currentResponseGroup.nextStep();
        this.checkStep();
        this.fixIllustration();
        window.scrollTo(0, 0);
        this.$store.state.currentStep.validate();
    }

    public checkStep() {
        const index = this.$store.state.currentResponseGroup.branch.steps.findIndex((branchStep: StepEntity) => {
            return branchStep.id === this.$store.state.currentStep.id;
        });
        if (index > -1) {
            this.stepIsFirst = index === 0;
            this.stepIsLast = index === this.$store.state.currentResponseGroup.branch.steps.length - 1;
            return;
        }
        this.stepIsFirst = false;
    }

    public getIcon(directory: string, iconName: string) {
        return '/static/' + IconRegistry.getIcon(directory, iconName);
    }

    public getPicture(directory: string, pictureName: string) {
        return '/static/' + directory + '/' + pictureName;
    }

    removeAdditionalSection(section: Section) {
        this.$store.dispatch('removeAdditionalResponseGroup', section).then(() => {
            this.step.validate();
            this.fixIllustration();
        });
    }

    public fixIllustration() {
        const illustrations = document.querySelectorAll('.stick-this-to-bottom');
        const stepLeft = document.querySelector('.step-left');
        const stepRight = document.querySelector('.step-right');
        const marginBottom = 16;

        if (null === stepLeft || null === stepRight) {
            return;
        }
        const stepRightRect = stepRight.getBoundingClientRect();
        const stepLeftWidth = stepLeft.clientWidth;
        const bottom = stepRightRect.bottom;
        const documentClientHeight = document.documentElement.clientHeight;
        const diff = bottom - documentClientHeight;
        illustrations.forEach((illustration: Element) => {
            illustration.style.maxWidth = (stepLeftWidth + 'px');
            if (diff >= 0) {
                illustration.style.bottom = marginBottom + 'px';
            } else {
                illustration.style.bottom = marginBottom + (-1 * diff) + 'px';
            }
        });
    }

    public scrollToLastQuestion() {
        const length = this.$store.state.currentBranch.validQuestions.length;

        if (length === 0) {
            return;
        }
        const lastQuestion = this.$store.state.currentBranch.validQuestions[length - 1];

        const refs = this.$refs['question-' + lastQuestion.id];
        const elm = refs[0].$el;
        window.scroll(0, elm.offsetTop);
    }

    mounted() {
        // console.log(this.step)
        // console.log(this.$store.state.currentBranch)
        // this.$store.state.currentBranch.questions.forEach((q)=>{
        //     console.log(q.label)
        //     // console.log(q)
        // })
        // this.fixIllustration();
        // window.onscroll = () => this.fixIllustration();
        // window.onresize = () => this.fixIllustration();
        // window.placeCopyright();
        window.scrollTo(0, 0);
        // this.step.validate();
        // this.checkStep();
        this.showFixedProgressBar();
        window.addEventListener('resize', this.showFixedProgressBar);
        window.addEventListener('scroll', this.showFixedProgressBar);
        this.disable();
        // console.log(this.step);
        // this.scrollToLastQuestion();
    }

    destroyed() {
        window.removeEventListener('resize', this.showFixedProgressBar);
        window.removeEventListener('scroll', this.showFixedProgressBar);
    }

    showFixedProgressBar() {
        const progressBar = this.$refs['progress'];
        const coords = progressBar.getBoundingClientRect();
        this.mainProgressHidden = coords.top < 75;
    }

    // calculateStepHeadHeight(){
    //     const stepHead = this.$refs['stepHead'];
    //     const questionHeight = this.$refs['questionContainer'];
    //     console.log(stepHead);
    //     const height = stepHead.offsetHeight;
    //     questionHeight.style.marginTop = height + 'px';
    //
    // }
}
